import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import "@fontsource-variable/plus-jakarta-sans";
import "./index.css";
import App from "./App";
import { TooltipProvider } from "./components/ui/tooltip";
import { ApiError } from "./lib/api";
import { applyTheme } from "./lib/theme";

// Új verzió után a régi oldal darabjai (chunkok) eltűnnek: ilyenkor egyszer frissítünk.
window.addEventListener("vite:preloadError", (e) => {
  e.preventDefault();
  if (sessionStorage.getItem("propsys.chunkReload") === "1") return;
  sessionStorage.setItem("propsys.chunkReload", "1");
  window.location.reload();
});

// Alap (propsys) téma azonnal, hogy ne villanjon színtelen felület a szervezeti arculat betöltése előtt.
applyTheme(null, null);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (count, err) => !(err instanceof ApiError && err.status < 500) && count < 2,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <App />
        <Toaster position="top-center" richColors closeButton toastOptions={{ className: "!rounded-2xl !font-sans" }} />
      </TooltipProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
